import React, {useState, useEffect} from 'react'
import NavBar from '../components/NavBar'
import Footer from '../components/Footer'
import CatalogueHeading from '../components/CatalogueHeading'
import Products from '../components/Products'
import Contact from '../components/Contact'

const Catalogue = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);


  return (
    <>
      <>
        {loading ? (
          <>
            <div className="w-full h-screen flex justify-center items-center">
              <div className="flex">
                <div
                  className="w-12 h-12 rounded-full animate-spin
                    border-y-4 border-solid border-[green-500] border-t-transparent"
                ></div>
              </div>
            </div>
          </>
        ) : (
          <>
            <NavBar />
            <div className="">
              <CatalogueHeading />
              <Products />
            </div>
            <hr className="text-darkBlue opacity-75" />
            <Contact />
            <Footer />
          </>
        )}
      </>
    </>
  );
}

export default Catalogue